import {SignatureMethodEnum} from '../../files/files.model';
import {SignatureMethodDto} from '../documents.service';

/**
 * Maps the methods offered by the client to the ones the UI knows about, falling back to the
 * default one when the client offers none.
 */
export function getAvailableSignatureMethods(signatureMethods: SignatureMethodDto[]): SignatureMethodEnum[] {
  const allowedSignatureMethods = new Set<SignatureMethodEnum>(Object.values(SignatureMethodEnum));
  const availableMethods = (signatureMethods ?? [])
    .map((signatureMethod) => signatureMethod?.name)
    .filter((signatureMethodName) => allowedSignatureMethods.has(signatureMethodName));
  return availableMethods.length > 0 ? availableMethods : [SignatureMethodEnum.MANUAL];
}

/**
 * Keeps only the methods still offered by the client, in the order they are offered.
 */
export function sortByOptionOrder(options: SignatureMethodEnum[],
                                  methods: SignatureMethodEnum[]): SignatureMethodEnum[] {
  return (options ?? []).filter((option) => (methods ?? []).includes(option));
}

export function defaultSignatureMethod(options: SignatureMethodEnum[]): SignatureMethodEnum {
  return (options ?? []).includes(SignatureMethodEnum.MANUAL)
    ? SignatureMethodEnum.MANUAL
    : (options ?? [])[0];
}
